import util from '@bmp-vue/core/api/util'
const controller = 'Autenticacao'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  Autenticar: function (login) {
    return util.Axios.Post(controller + '/AccessToken', login)
  },
  Logout: function (documento, refreshToken) {
     return new Promise(resolve => {
      resolve('');
    });
    // return util.Axios.Delete(controllerVersionado + '/AccessToken', refreshToken)
  },
  RefreshToken: function (token) {
    var dto = { RefreshToken: token }
    return util.Axios.Post(controller + '/RefreshToken', dto)
  },
  JumpCloudAuthorizeUrl: function () {
    return process.env.VUE_APP_ROOT_API + controller + '/JumpCloud/Authorize'
  },
  JumpCloudToken: function (codigo) {
    return util.Axios.Post(controller + '/JumpCloud/Token', { Codigo: codigo })
  },
  SolicitarLinkSenha: function (dto) {
    return util.Axios.Post(controller + `/SolicitarLinkSenha/${dto}`, null)
  },
  RecuperarSenha: function (dto) {
    var request = { Password: dto.NovaSenha, ConfirmPassword: dto.NovaSenha, Code: dto.Token }
    return util.Axios.Post(controller + `/RecuperarSenha/${dto.Login}`, request)
  },
  ValidaTokenSenha: function (username, token) {
    const params = { username: username, token: token }
    return util.Axios.GetParams(controller + '/ValidaTokenSenha', params)
  },
  FidoU2fAuthorize: function (dto, usId, isvalidate) {
    var request = { AssertionResponse: dto, UsId: usId, IsValidateMfa: isvalidate }
    return util.Axios.Post(controller + '/FidoU2fAuthorize', request)
  },
  FidoU2fOptions: function (userName) {
    var request = { UserName: userName }
    return util.Axios.Post(controller + '/FidoU2fOptions', request)
  },
  AuthCompany: function (token, parceiro) {
    var dto = { RefreshToken: token, CodigoParceiro: parceiro }
    return util.Axios.Post(controller + '/AuthCompany', dto)
  }
})
